<template>
  <div class="main-content-box main-content-box-detail content-width-1300">
    <div class="task-base-info" v-if="learningData && learningData.taskBaseInfo">
      <span class="span-icon span1">
        <i class="iconfont iconlaoshi"></i>
        {{learningData.taskBaseInfo.authorName}}
      </span>
      <span class="span-icon span2">
        <i class="iconfont iconkechengzhongxin"></i>
        {{infoObj.subjectName}}
      </span>
      <span class="span-icon span3">
        <i class="iconfont iconxiaozu"></i>
        {{learningData.taskBaseInfo.classOrGroupName}}
      </span>
      <span class="span-icon span4">
        <i class="iconfont iconkaishijieshushijian"></i>
        {{learningData.taskBaseInfo.startTime1}} 至 {{learningData.taskBaseInfo.dueTime1}}
      </span>
      <!-- learningStatus 学习状态 0:未开始 1:学习中 2:已完成 -->
      <!-- exerciseStatus 练习状态 0:未提交 1:练习中 2:已提交 -->
      <span
        class="span-icon span5"
        v-if="(resourceList.length && !learningData.taskBaseInfo.learningStatus) || 
          (!resourceList.length && exerciseList.length && !learningData.taskBaseInfo.exerciseStatus)"
      >
        <i class="iconfont iconweikaishi1"></i>
        未开始
      </span>
      <span
        class="span-icon span5"
        v-else-if="(resourceList.length && exerciseList.length && learningData.taskBaseInfo.exerciseStatus !== 2) || 
          (resourceList.length && !exerciseList.length && learningData.taskBaseInfo.learningStatus !== 2) || 
          (!resourceList.length && exerciseList.length && learningData.taskBaseInfo.exerciseStatus !== 2)"
      >
        <i class="iconfont iconjinhangzhong"></i>
        学习中
      </span>
      <span
        class="task-complete-img"
        v-else-if="(resourceList.length && learningData.taskBaseInfo.learningStatus === 2 && !exerciseList.length) || 
          exerciseList.length && learningData.taskBaseInfo.exerciseStatus === 2
        "
      >
        <img class="complete-img" src="../../assets/task-complete.png" alt />
      </span>
      
      <span class="span-icon span6 pie-ercentage" v-if="learningData.taskBaseInfo.options">
        <PiePercentage :options="learningData.taskBaseInfo.options" />
        {{learningData.taskBaseInfo.objectiveCorrectedNum}} / {{learningData.taskBaseInfo.objectiveTotal}}
      </span>
    </div>
    <div class="task-base-info" v-else></div>
    <div 
      class="learning-c-tabs"
      v-loading="dataLoading"
      element-loading-text="数据正在跑步前进中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
      >
      <el-tabs v-if="true" v-model="tabsActive" type="card" @tab-click="handleTabClick">
        <!-- 基本信息 -->
        <el-tab-pane label="基本信息" name="basicInfo">
          <div class="module-content-box">
            <div class="form-item">
              <span class="form-label">主题</span>
              <span class="form-content">{{infoObj.title}}</span>
            </div>
            <div class="form-item">
              <span class="form-label">章节目录</span>
              <span class="form-content">{{infoObj | chapterFilter}}</span>
            </div>
            <div class="form-item">
              <span class="form-label">难易程度</span>
              <span
                v-if="infoObj.difficulty"
                class="form-content"
              >{{infoObj.difficulty === 1 ? '简单' : (infoObj.difficulty ===2 ? '适中' : '困难')}}</span>
            </div>
            <div class="form-item">
              <span class="form-label">学习说明</span>
              <span class="form-content">{{infoObj.description}}</span>
            </div>
            <div class="form-item">
              <span class="form-label">学习目标</span>
              <span class="form-content">{{infoObj.target}}</span>
            </div>
            <div class="form-item">
              <span class="form-label">教师备注</span>
              <span class="form-content">{{infoObj.remarks}}</span>
            </div>
            <div class="form-item">
              <span class="form-label">预计耗时</span>
              <span v-if="infoObj.estimated" class="form-content">{{infoObj.estimated}}分钟</span>
            </div>
          </div>
        </el-tab-pane>
        <!-- 学习资源 -->
        <el-tab-pane label="学习资源" name="resourse" v-if="resourceList.length" :disabled="false && !learningTaskId">
          <!-- 组件: 学习资源展示列表 -->
          <LearnResource
            v-if="resourceList.length"
            :sort="true"
            :resource-list="resourceList"
            :add-to-flex-num="addToFlexNum"
            :edit-power="learningData.taskBaseInfo.status === 2 ? false : true"
            :media-screen="true"
            @handlerResourceClick="_resourceClick"
          />
          <div class="data-empty" v-else>
            <img src="../../assets/task-empty.png" alt />
            <p>暂未添加学习资源</p>
          </div>
        </el-tab-pane>
        <!-- 练习 -->
        <el-tab-pane label="练习" name="exercise" v-if="exerciseList.length" :disabled="false && !learningTaskId">
          <!-- 组件：习题列表 -->
          <div class="exercise-list" v-if="exerciseList.length">
            <ExerciseList
              ref="exerciseComponent"
              :data-list="exerciseList"
              :editPower="true"
              :component-type="exerciseListComponentType"
              @handlerUpdata="_upDataExercise"
            />
          </div>

          <div class="data-empty" v-else>
            <img src="../../assets/task-empty.png" alt />
            <p>暂未添加练习</p>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="bottom-btns" v-if="learningData && learningData.taskBaseInfo" id="buttomBtns">
        <el-button
          v-if="!learningData.taskBaseInfo.learningStatus && !learningData.taskBaseInfo.exerciseStatus && learningData.taskBaseInfo.status === 1"
          type="primary"
          size="small"
          :loading="okLoading"
          @click="!okLoading && _statusUpdate(1)"
        >开始学习</el-button>
        <el-button
          v-if="tabsActive == 'exercise' && learningData.taskBaseInfo.status === 1  && learningData.taskBaseInfo.exerciseStatus === 1 && exerciseList.length"
          type="primary"
          size="small"
          :loading="okLoading && saveBtnType === 2"
          @click="!okLoading && _statusUpdate(2)"
        >保存</el-button>
        <el-button
          v-if="tabsActive == 'exercise' && learningData.taskBaseInfo.status === 1  && learningData.taskBaseInfo.exerciseStatus === 1 && exerciseList.length"
          type="primary"
          size="small"
          :loading="okLoading && saveBtnType === 3"
          :disabled="!canSubmit"
          @click="!okLoading && _statusUpdate(3)"
        >提交练习</el-button>
        <el-button size="small" @click="_back">返回</el-button>
      </div>
    </div>

    <!-- 提交 的弹框 -->
    <el-dialog
      :visible.sync="operateDialogVisible"
      :append-to-body="true"
      :before-close="_operateDialogClose"
      custom-class="submit-el-dialog"
      >
      <div class="dialog-content">
        <p class="dialog-line"><span class="color-main">{{learningData.taskBaseInfo && learningData.taskBaseInfo.authorName}}</span>老师已经收到你提交的练习啦~</p>
        <p v-if="resultExercise.alSubjective" class="dialog-line">
          本次学习共耗时{{resultExercise.estimated}}分钟，<br />继续加油哦~
        </p>
        <p class="dialog-line" v-else>
          本次学习共耗时{{resultExercise.estimated}}分钟，<br />正确率
          <span
            :class="{
              'font-bold': true,
              'color-red': resultExercise.objectiveCorrectedNum / resultExercise.objectiveTotal <= 0.5,
              'color-main': resultExercise.objectiveCorrectedNum / resultExercise.objectiveTotal > 0.5,
            }"
            class="font-bold color-red"
          >{{resultExercise.objectiveCorrectedNum}}/{{resultExercise.objectiveTotal}}</span>
          ，继续加油哦~
        </p>
      </div>

      <img class="bg-bottom-img" src="../../assets/dialog-bg.png" alt />
    </el-dialog>
  </div>
</template>
<script>
import { originUrl } from "config/constant";
import { formatDateTime } from "utils/util";

import LearnResource from "components/learn-task/learn-resource";
import ExerciseList from "components/learn-task/exercise-list";
import LearnTaskPreview from "components/learn-task/learn-task-preview";
import PiePercentage from "components/learn-task/pie-percentage";

import { reqGetTaskAndLearningInfo, reqTaskStatusModify } from "api/my-task";
export default {
  components: {
    LearnResource,
    ExerciseList,
    LearnTaskPreview,
    PiePercentage
  },
  data() {
    return {
      dataLoading: true,
      okLoading: false,
      tabsActive: "basicInfo", // basicInfo resourse exercise
      learningData: {},
      infoObj: {},
      resourceList: [],
      exerciseList: [],
      // exerciseComponentType: 4,
      addToFlexNum: 0,
      dragging: false,
      dialogVisibleResource: false,
      dialogVisible: false,
      insertIndex: null,
      exerciseEditData: null,
      nowLearningData: null,
      learningTaskId: null,
      dialogVisiblePreview: false,
      operateDialogVisible: false,
      resultExercise: {},
      canSubmit: false,
      saveBtnType: null,
    };
  },
  filters: {
    chapterFilter(val) {
      if (!val.subjectName) {
        return "";
      }
      let str = `${val.subjectName}/${val.editionName}/${val.volumeName}/${val.chapterOneTitle}`;
      if (val.chapterTwoTitle) {
        str += `/${val.chapterTwoTitle}`;
      } else if (val.chapterThreeTitle) {
        str += `/${val.chapterThreeTitle}`;
      }
      return str;
    }
  },
  computed: {
    /**
     * 保存按钮是否可点击
     * **/
    saveBtnDis() {
      if (this.okLoading) {
        return true;
      } else if (this.tabsActive === "resourse" && !this.resourceList.length) {
        if (
          this.learningData &&
          this.learningData.learningDetailList &&
          !this.learningData.learningDetailList.length
        ) {
          return true;
        } else {
          return false;
        }
      } else if (this.tabsActive === "exercise" && !this.exerciseList.length) {
        if (
          this.learningData &&
          this.learningData.exercise &&
          !this.learningData.exercise.exerciseDetailList
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    /**
     * 分配按钮是否可点击
     * **/
    assignBtn() {
      if (!this.learningTaskId) {
        return false;
      } else if (!this.resourceList.length && !this.exerciseList.length) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 练习组件类型判断
     * **/
    exerciseListComponentType() {
      // if(this.learningData.taskBaseInfo.status !== 1) {
      //   return 6 ;
      // }
      if (this.resourceList.length && this.exerciseList.length) {
        if (
          this.learningData.taskBaseInfo.learningStatus === 2 &&
          this.learningData.taskBaseInfo.exerciseStatus !== 2 &&
          this.learningData.taskBaseInfo.status === 1
        ) {
          return 4;
        } else if (
          this.learningData.taskBaseInfo.learningStatus === 2 &&
          this.learningData.taskBaseInfo.exerciseStatus === 2
        ) {
          return 5;
        } else {
          return 6;
        }
      } else if (!this.resourceList.length) {
        if (this.learningData.taskBaseInfo.exerciseStatus === 2) {
          return 5;
        }else if(!this.learningData.taskBaseInfo.exerciseStatus || this.learningData.taskBaseInfo.status !== 1) {
          return 6;
        } else {
          return 4;
        }
      }
    }
  },
  methods: {
    /**
     * 当前任务状态异常后的操作
     * **/
    _taskError(code) {
      if (code === 13001) {
        this.$message({
          type: "error",
          message: "当前任务已被取消",
          duration: 2000
        });
        this.$router.push({
          path: "/my-task/list"
        });
      } else if (code === 13002) {
        this.$message({
          type: "error",
          message: "当前任务已过期",
          duration: 2000
        });
        this._getDetailInfo();
      } else if (code === 13003) {
        this.$message({
          type: "error",
          message: "任务已提交，不可重复提交",
          duration: 3000
        });
        this._getDetailInfo();
      }
    },

    /**
     * 点击资源
     * **/
    _resourceClick(item) {
      if (this.learningData.taskBaseInfo.status === 1) {
        this._statusUpdate(4, item);
      }
    },

    /**
     * 开始学习/保存提交练习，资源查看下载的状态修改
     * **/
    _statusUpdate(type, item) {
      // 1--开始 2--保存 3--提交 4--资源查看
      this.saveBtnType = type;
      let obj = {
        studentTaskId: this.studentTaskId
      };
      if (type === 1) {
        // 开始
        obj.isStarting = true;
      } else if (type === 2 || type === 3) {
        // 保存 提交
        if(type === 3 && !this._operateExercise(type)) {
          this.saveBtnType = null;
          return;
        }
        obj.exerciseDetailList = this._operateExercise(type);
        if (type === 3) {
          obj.isCommit = true;
        }
      } else if (type === 4) {
        // 资源查看
        obj.learningDetailId = item.id;
        if (!this.learningData.taskBaseInfo.learningStatus) {
          obj.isStarting = true;
        }
      }
      this.okLoading = true;
      // return setTimeout(() => {
      //   this.okLoading = false;
      //   this.saveBtnType = null;
      // }, 3000);
      return reqTaskStatusModify(obj)
        .then(res => {
          this.okLoading = false;
          this.saveBtnType = null;
          if (res.code === 0) {
            this._statusUpdateSuccess(type, item, res.data);
          } else if (res.code === 13001 || res.code === 13002 || res.code === 13003) {
            this._taskError(res.code);
          } else {
            this.$message({
              type: "error",
              message:
                type === 1
                  ? "开始学习请求失败"
                  : type === 2
                  ? "保存失败"
                  : type === 3
                  ? "提交失败"
                  : "资源查看状态修改失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.okLoading = false;
          this.saveBtnType = null;
          console.log("err", err);
        });
    },

    /**
     * 提交或保存前的数据处理
     * 1--开始 2--保存 3--提交 4--资源查看
     * **/
    _operateExercise(type) {
      let l = [];
      let _exerciseList = this.$refs.exerciseComponent.exerciseList;
      if (!_exerciseList || !_exerciseList.length) {
        return l;
      }
      for (let x of _exerciseList) {
        let obj = {
          exerciseDetailId: x.id
        };
        if (x.studentAnswer && x.studentAnswer.id) {
          obj.id = x.studentAnswer.id;
        }
        if (x.type <= 2) {
          // 单选 多选
          let _answer = [];
          for (let i = 0; i < x.params.options.length; i++) {
            let y = x.params.options[i];
            if (y.isCorrect1) {
              _answer.push(i);
            }
          }
          obj.answer = _answer.join(",");
        } else if (x.type === 3) {
          // 选择题
          if (x.params.isCorrect1 === true) {
            obj.answer = "true";
          } else if (x.params.isCorrect1 === false) {
            obj.answer = "false";
          }
        } else if (x.type === 4 && x.params.isCorrect1) {
          // 简答题
          obj.answer = x.params.isCorrect1;
          if(type === 3 && x.params.isCorrect1.length < x.params.min) {
            this.$refs.exerciseComponent._exerciseError();
            return false;
          }
        }
        if (obj.answer) {
          l.push(obj);
        }
      }
      return l;
    },

    /**
     * 状态操作成功
     * type 1--开始 2--保存 3--提交 4--资源查看
     * **/
    _statusUpdateSuccess(type, item, res) {
      if (type === 1) {
        // 1--开始
        this.learningData.taskBaseInfo.learningStatus = 1;
        this.learningData = Object.assign({}, this.learningData);
        if (this.resourceList.length) {
          this.tabsActive = "resourse";
          this._computeFlexNum();
        } else {
          this.tabsActive = "exercise";
          this.learningData.taskBaseInfo.exerciseStatus = 1;
        }
      } else if (type === 2) {
        // 2--保存
        this.$message({
          type: "success",
          message: "保存成功",
          duration: 2000
        });
      } else if (type === 3) {
        // 3--提交
        // if (this.canSubmit) {
        //   this.learningData.taskBaseInfo.exerciseStatus = 2;
        //   this.canSubmit = false;
        // }
        let alSubjective = true;
        let _find = this.exerciseList.findIndex(ele => ele.type !== 4);
        if(_find !== -1) {
          alSubjective = false;
        }
        this.resultExercise = Object.assign({alSubjective}, res);
        this.operateDialogVisible = true;
        this._getDetailInfo();
      } else if (type === 4) {
        // 4--资源查看
        if (res.learnStatus || res.learningStatus) {
          this.learningData.taskBaseInfo.learningStatus =
            res.learnStatus || res.learningStatus;
        }

        this.resourceList[item.index].isWatched = true;
        this.resourceList = [...this.resourceList];
        if (
          this.learningData.taskBaseInfo.learningStatus === 2 &&
          !this.learningData.taskBaseInfo.exerciseStatus
        ) {
          this.learningData.taskBaseInfo.exerciseStatus = 1;
        }
      }
    },

    _operateDialogClose() {
      this.operateDialogVisible = false;
    },

    /**
     * 返回
     * **/
    _back() {
      this.$router.push({
        path: "/my-task/list"
      });
    },

    /**
     * 切换tab
     * **/
    handleTabClick() {
      if (this.tabsActive === "resourse") {
        this._computeFlexNum();
        // if(this.resourceList.length && !this.learningData.taskBaseInfo.learningStatus) {
        //   this.$message({
        //     type: "warning",
        //     message: "点击下方的“开始学习”按钮开始学习"
        //   });
        //   this.$nextTick(() => {
        //     document
        //       .getElementById("buttomBtns")
        //       .scrollIntoView({ behavior: "smooth" });
        //   });
        // }
      }
      if (this.learningData.taskBaseInfo.status !== 1) {
        return;
      }
      if (this.tabsActive === "exercise" && this.exerciseList.length) {
        if (
          this.resourceList.length &&
          this.learningData.taskBaseInfo.learningStatus !== 2
        ) {
          this.$message({
            type: "warning",
            message: "要先完成“学习资源”的学习才可以进行答题哦"
          });
        } else if (
          !this.resourceList.length &&
          !this.learningData.taskBaseInfo.learningStatus
        ) {
          this.$message({
            type: "warning",
            message: "点击下方的“开始学习”按钮才可以进行答题哦"
          });
          this.$nextTick(() => {
            document
              .getElementById("buttomBtns")
              .scrollIntoView({ behavior: "smooth" });
          });
        } else {
          this._canSubmit();
        }
      }
    },

    /**
     * 更新习题列表
     * **/
    _upDataExercise(data) {
      this.exerciseList = JSON.parse(JSON.stringify(data));
      this._canSubmit();
    },

    /**
     * 是否可提交
     * **/
    _canSubmit() {
      if (
        this.tabsActive !== "exercise" ||
        this.learningData.taskBaseInfo.exerciseStatus === 2 ||
        !this.exerciseList.length
      ) {
        return false;
      }
      let _isComplete = true;
      for (let x of this.exerciseList) {
        if (x.type === 1 || x.type === 2) {
          let _isCorrect1 = x.params.options.findIndex(ele => ele.isCorrect1);
          if (_isCorrect1 === -1) {
            _isComplete = false;
            break;
          }
        } else if (
          x.type === 3 &&
          Object.prototype.toString.call(x.params.isCorrect1) !==
            "[object Boolean]"
        ) {
          _isComplete = false;
          break;
        } else if (
          x.type === 4 &&
          !x.params.isCorrect1
        ) {
          _isComplete = false;
          break;
        }
      }
      this.canSubmit = _isComplete;
    },

    /**
     * 获取详情
     * **/
    _getDetailInfo(type) {
      let obj = {
        learningTaskId: this.learningTaskId,
        studentTaskId: this.studentTaskId,
        isEdit: true
      };
      return reqGetTaskAndLearningInfo(obj)
        .then(res => {
          this.dataLoading = false;
          if (res.code === 0) {
            let _res = Object.assign({}, res.data);
            this.learningData = _res;
            // learningStatus 学习状态 0:未开始 1:学习中 2:已完成
            // exerciseStatus 练习状态 0:未提交 1:练习中 2:已提交
            // this.learningData.taskBaseInfo.learningStatus = 2;
            // this.learningData.taskBaseInfo.exerciseStatus = 1;
            if(this.learningData.taskBaseInfo.exerciseStatus === 2) {
              let _objectiveTotal = _res.taskBaseInfo.objectiveTotal ? _res.taskBaseInfo.objectiveTotal : 0;
              let _objectiveCorrectedNum = _res.taskBaseInfo.objectiveCorrectedNum ? _res.taskBaseInfo.objectiveCorrectedNum : 0;
              let _options = [
                {
                  value: _objectiveCorrectedNum,
                  name: "正确",
                  selected: true
                },
                {
                  value: _objectiveTotal - _objectiveCorrectedNum,
                  name: "错误"
                }
              ];
              if(_objectiveCorrectedNum === _objectiveTotal && _objectiveTotal === 0) {
                _options[1].value = 1;
              }
              this.learningData.taskBaseInfo.options =_options;
            }
            this.learningData.taskBaseInfo.startTime1 = this.learningData
              .taskBaseInfo.startTime
              ? formatDateTime(
                  new Date(this.learningData.taskBaseInfo.startTime),
                  "yyyy-MM-dd HH:mm"
                )
              : "-";
            this.learningData.taskBaseInfo.dueTime1 = this.learningData
              .taskBaseInfo.dueTime
              ? formatDateTime(
                  new Date(this.learningData.taskBaseInfo.dueTime),
                  "yyyy-MM-dd HH:mm"
                )
              : "-";
            let _basicInfo = Object.assign({}, _res.learningBaseInfo);
            this.infoObj = _basicInfo;
            this.learnedDetailIdList = _res.learnedDetailIdList
              ? _res.learnedDetailIdList
              : [];
            if (
              _res.learningDetailList.length &&
              this.learnedDetailIdList.length
            ) {
              let _resourceList = [..._res.learningDetailList];
              for (let x of _resourceList) {
                if (this.learnedDetailIdList.includes(x.id)) {
                  x.isWatched = true;
                }
              }
              this.resourceList = [..._resourceList];
            } else {
              this.resourceList = [..._res.learningDetailList];
            }
            this.exerciseList = _res.exercise.exerciseDetailList
              ? [..._res.exercise.exerciseDetailList]
              : [];
            if (this.tabsActive === "resourse") {
              this._computeFlexNum();
            }
          } else if (res.code === 13001) {
            this._taskError(res.code);
          } else {
            this.$message({
              type: "error",
              message: "获取详情失败",
              duration: 2000
            });
          }
        })
        .catch(err => {
          this.dataLoading = false;
          console.log("error", err);
        });
    },

    /**
     * 计算flex布局要填充几个
     * **/
    _computeFlexNum() {
      if (!this.resourceList.length) {
        this.addToFlexNum = 0;
        return;
      }
      this.$nextTick(() => {
        let ele = $("#editResourceList");
        let _w1 = ele.width();
        let ele1 = $("#editResourceList .item-wrapper").eq(0);
        let _w2 = ele1.outerWidth() + parseInt(ele1.css("marginRight"));
        let _num1 = Math.floor(_w1 / _w2); // 一行能放下多少
        let _num2 = Math.ceil(this.resourceList.length / _num1); // 最多能放多行
        if (this.resourceList.length % _num1) {
          if (_num1 * _num2 - this.resourceList.length > 0) {
            this.addToFlexNum = _num1 * _num2 - this.resourceList.length;
          } else {
            this.addToFlexNum = 0;
          }
        } else {
          this.addToFlexNum = 0;
        }
      });
    }
  },
  created() {
    let _query = this.$route.query;
    if (_query.id) {
      this.learningTaskId = _query.id ? Number(_query.id) : null;
      this.studentTaskId = _query.id1 ? Number(_query.id1) : null;
    }
    this._getDetailInfo();
  },
  beforeRouteLeave (to, from, next) {
    next();
  }
};
</script>
<style lang="less">
@color-main: #03B2B2;
@height-calc1: calc(100vh - 180px - 40px - 40px - 30px - 60px);
// @height-calc2: calc(100vh - 180px - 40px - 40px - 30px - 60px - 45px - 2px);
@height-calc2: calc(100vh - 230px - 45px - 60px - 30px);
.main-content-box-detail {
  min-height: calc(100vh - 180px);
  padding: 20px 15px 0;
  background-image: none;
  .task-base-info {
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    border-radius: 8px;
    background: #B0E4E4;
    position: relative;
    .span-icon {
      font-size: 14px;
      margin-right: 30px;
      vertical-align: middle;
      display: inline-block;
    }
    .iconfont {
      padding-right: 6px;
    }
    .iconlaoshi {
      color: #7bcbff;
    }
    .iconkechengzhongxin {
      color: #55dcbd;
    }
    .iconxiaozu {
      color: #80b6ff;
    }
    .iconkaishijieshushijian {
      color: #ffb173;
    }
    .iconweikaishi1 {
      color: #cdcdcd;
    }
    .iconjinhangzhong {
      color: #91a3ff;
    }
    .icontijiao {
      color: #509563;
    }
    .pie-ercentage {
      .pieEcharts {
        vertical-align: top;
        margin-top: 10px;
        margin-right: 6px;
      }
    }
    .task-complete-img {
      position: absolute;
      right: 20px;
      top: -14px;
    }
  }
  .learning-c-tabs {
    margin-top: 30px;
    // min-height: @height-calc1;
    overflow: hidden;
    position: relative;

    .el-tabs {
      // min-height: @height-calc1;

      .el-tabs__header {
        margin: 0;
        border-bottom: 0px solid #e4e7ed;
        height: 45px;

        .el-tabs__nav {
          border-left: 1px solid @color-main;
          border-top: 1px solid @color-main;
          border-right: 1px solid @color-main;
          border-left: 1px solid @color-main;
          border-bottom: none;
          border-radius: 6px 6px 0 0;
          overflow: hidden;
          background-color: transparent;

          .el-tabs__item {
            border-width: 0;
            border-color: #d2d2d2;
            background: #eaeaea;
            color: #ffffff;
            height: 45px;
            line-height: 45px;
            width: 100px;
            text-align: center;
            padding: 0 !important;
            font-size: 14px;
            float: left;
            background-color: @color-main;
            &.is-disabled {
              cursor: not-allowed;
              color: #666;

              &:hover {
                color: #666;
              }
            }

            &.is-active {
              color: @color-main;
              z-index: 10;
              background-color: #ffffff;
              font-weight: bold;
            }

            &:hover {
              &:not(.is-active) {
                background: #67D9D9;
              }
            }
          }

          .el-tabs__item:focus.is-active.is-focus:not(:active) {
            box-shadow: none;
          }
          #tab-basicInfo {
          }
          #tab-resourse {
          }
          #tab-exercise {
          }
        }
      }

      .el-tabs__content {
        border: 1px solid @color-main;
        // border-top: 0px solid #D2D2D2;
        border-radius: 0 8px 8px 8px;
        background: #fff;
        min-height: @height-calc2;
        position: static;
        .el-tab-pane {
          width: 100%;
          overflow: auto;
        }

        #pane-basicInfo {
          // min-height: @height-calc2;
          height: 100%;
          min-height: 550px;
          padding: 34px 30px 20px 24px;
          .module-content-box {
            width: 100%;
            padding-right: 30px;

            .form-item {
              width: 100%;
              padding-bottom: 24px;

              .form-label {
                display: inline-block;
                width: 92px;
                height: 26px;
                line-height: 26px;
                font-size: 14px;
                font-weight: bold;
                text-align: center;
                color: #FFF;
                background: url('../../assets/label-bg.png') no-repeat;
              }

              .form-content {
                display: inline-block;
                width: calc(100% - 120px);
                padding-left: 28px;
                padding-right: 20px;
                color: #666666;
                vertical-align: top;
                line-height: 26px;
              }
            }
          }
        }

        #pane-resourse {
          // min-height: @height-calc2;
          height: 100%;
          min-height: 550px;
          padding-left: 0;
          padding-top: 16px;
          // position: relative;
          .edit-resource-list {
            height: 100%;
            padding-left: 20px;
            padding-right: 20px;
          }

          .add-resource-btn {
            padding-left: 30px;
            padding-bottom: 6px;

            .el-button {
            }
          }
        }

        #pane-exercise {
          // min-height: @height-calc2;
          height: 100%;
          min-height: 550px;
          padding-left: 0;
          padding-top: 16px;
          width: 100%;
          position: relative;

          .add-exercise-btn {
            padding-left: 30px;
            padding-bottom: 6px;
          }

          .exercise-list {
            padding: 10px 20px 0 60px;
            width: 100%;
            height: 100%;
            overflow: auto;
            .component-exercise-list {
              height: auto;
            }
          }
        }

        .data-empty {
          height: 140px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;

          img {
            height: 110px;
          }
          p {
            color: #999;
            font-size: 14px;
            padding-top: 30px;
          }
        }
      }
    }

    .bottom-btns {
      width: 100%;
      height: 40px;
      text-align: center;
      margin-top: 20px;

      .el-button {
        vertical-align: top;
        padding: 12px 0;
        & + .el-button {
          margin-left: 110px;
        }
      }
      .btn-bg {
        width: 100px;
        height: 40px;
        line-height: 40px;
        padding: 0;
        > span {
          display: inline-block;
          width: 100%;
          height: 100%;
          margin-top: 6px;
          line-height: 1;
          position: relative;
          .btn-bg-1 {
            position: absolute;
            height: 44px;
            left: -20px;
            top: -10px;
          }
          .btn-bg-2 {
            position: absolute;
            right: 1px;
            top: -3px;
          }
          .dashed-border {
            border: 1px dashed #a3d4a5;
            display: inline-block;
            width: calc(100% - 12px);
            height: calc(100% - 12px);
            padding: 6px 6px 6px 16px;
            background: transparent;
            border-radius: 4px;
            line-height: 16px;
          }
        }
      }
    }
  }
}
.submit-el-dialog {
  background: transparent;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  width: 380px;
  height: 200px;
  margin-top: 30vh !important;
  overflow: visible;
  .el-dialog__header {
    background: transparent;
    height: 16px;
    .el-dialog__headerbtn {
      top: 0px;
      right: -20px;
      font-size: 20px;
      &:hover {
        text-shadow: 0 0 2px #fff;
      }
    }
  }
  .el-dialog__body {
    height: 184px;
    padding: 36px;
    background: #fff;
    border-radius: 8px;
    border: 3px solid @color-main;
    position: relative;
    .dialog-line:first-of-type {
      font-size: 18px;
      line-height: 24px;
      height: 48px;
      margin-bottom: 10px;
    }
    .dialog-line:last-of-type {
      font-size: 16px;
      line-height: 30px;
    } 
    .bg-bottom-img {
      position: absolute;
      right: -32px;
      bottom: -24px;
    }
  }
}
</style>